
import { Component, Emit, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import RTCClient from "@/rtc/RTCClient";

@Component({})
export default class ClassIdCodeJoinComponent extends Vue {

  /**
   * 园区ID
   */
  @Prop({
    type: String,
    default: () => {
      return ''
    },
    required: true
  })
  gardenId

  /**
   * 用户认证TOKEN
   */
  @Prop({
    type: String,
    default: () => {
      return ''
    },
    required: true
  })
  token

  @Prop({
    type: String,
    default: null,
    required: true
  })
  userType

  // 是否显示加入课堂弹框的标志位
  showJoinClassroomDialogFlag = false
  // 加入课堂弹框内表单的对其方式
  labelPosition = 'right'
  // 加入课堂表单的绑定对象
  classroom = {
    classroomId: ''
  }
  // 加入课堂表单的校验规则
  rules = {
    classroomId: [
      { required: true, message: '请输入课堂ID码', trigger: 'blur' },
      { pattern: /^[0-9A-Za-z]{6}$/, message: '课堂ID码必须是六位数字或者字母', trigger: 'blur' }
    ]
  }
  submitButtonDisable = true
  joinErrorMessage = ''
  formValidateSuccess = true
  submitLoading = false
  // 当前客户端是否支持rtc，默认为false
  currentClientSupportRtc: boolean

  @Ref('form') from

  @Watch('classroom', { deep: true })
  classroomWatch() {
    this.joinErrorMessage = ''
    if (this.showJoinClassroomDialogFlag) {
      this.validate()
    }
  }

  created(): void {
    this.checkRtcSupport()
  }

  /**
   * 校验浏览器是否支持rtc
   */
  checkRtcSupport() {
    RTCClient.instance.isSupport().then(res => {
      const {isSupported} = res
      // 如果不支持，给出提示弹框
      this.currentClientSupportRtc = isSupported
      RTCClient.instance.dispose()
    }, err => {
      this.currentClientSupportRtc = false
      RTCClient.instance.dispose()
    }).catch(err => {
      this.currentClientSupportRtc = false
      RTCClient.instance.dispose()
    })
  }

  /**
   * 展示当前浏览器不支持rtc时的确认弹框
   */
  showRtcNotSupportConfirm() {
    let confirmTitle =
      '<div style="font-size: 16px;text-indent:2em;line-height: 30px">您当前使用的浏览器类型或版本不支持发起音视频双向通信。请更换至以下浏览器类型或版本后再试：\n' +
      'Chrome浏览器72或以上版本，Edge浏览器80或以上版本</div>';

    this.$elementConfirm(confirmTitle, "提示", {
      confirmButtonText: "确定",
      customClass: this.isMobile ? 'mobile-confirm-box' : '',
      dangerouslyUseHTMLString: true,
      showCancelButton: false,
      closeOnClickModal: false,
      transition: "",
      // type: 'warning'
    }).then(() => {
    })
  }

  /**
   * 打开加入马良笔双师课堂的弹框
   */
  showJoinClassroomDialog() {
    const _that = this;
    function showDialog() {
      if (!_that.currentClientSupportRtc) {
        _that.showRtcNotSupportConfirm()
        return
      }
      _that.classroom.classroomId = ''
      _that.joinErrorMessage = ''
      _that.showJoinClassroomDialogFlag = true
      _that.$nextTick(() => {
        _that.from.resetFields();
      })
    }

    if (this.currentClientSupportRtc === null || this.currentClientSupportRtc === undefined) {
      setTimeout(() => {
        showDialog();
      }, 1000)
    } else {
      showDialog();
    }
  }

  /**
   * 关闭加入马良笔双师课堂的弹框
   */
  closeJoinClassroomDialog() {
    this.showJoinClassroomDialogFlag = false
  }

  /**
   * 表单校验函数
   */
  validate() {
    // 如果输入框无内容，直接禁用
    if (!this.classroom.classroomId) {
      this.submitButtonDisable = true
      return
    }
    this.from.validate((valid) => {
      this.formValidateSuccess = valid
      this.submitButtonDisable = !valid
    })
  }

  /**
   * 提交表单
   */
  submitForm() {
    this.submitLoading = true
    this.joinErrorMessage = ''
    this.from.validate((valid) => {
      if (valid) {
        this.joinClassroom()
      } else {
        this.submitLoading = false
      }
    })
  }
  /**
   * 输入内容转为大写字母
   */
  toUppercase() {
    this.classroom.classroomId = this.classroom.classroomId.toUpperCase()
  }

  joinClassroom(): void {
    RTCClient.instance.getAuthInfo(
      this.token,
      this.classroom.classroomId,
      'PA',
      this.userType,
      this.gardenId
    ).then(res => {
      this.submitLoading = false
      this.$emit('joinClassroom', this.classroom.classroomId, res)
    }).catch(err => {
      switch (err.Code) {
        case 700:
        case 702:
        case 703:
          //  701:云端未知异常
          //  702:云端获取园区对应的rtc AppID和appkey 报错
          //  703:云端获取当前频道ID的可用性时报错
          this.joinErrorMessage = err.Message.UserMsg
          break
        case 701:
          this.$message.error('您当前的音视频通信认证令牌已超过最大允许时长。系统将自动结束当前课堂。')
          this.local$.clearLocal()
          this.cookie$.removeCookie("LWToken")
          //  用户的优课场域认证token时效，回到登录页面
          window.open(this.filePre$.loginUrl + "/logout", "_self")
          break
        case 704:
          //  当前请求的频道ID不可用
          this.joinErrorMessage = '*根据该课堂ID码未查询到当前正在发起的马良笔双师课堂！'
          break
        default:
          this.joinErrorMessage = err.Message.UserMsg
          break
      }
      this.submitLoading = false
    })
  }

}
